export function groupBy<T>(items: T[], getKey: (item: T) => string): Record<string, T[]> {
  return items?.reduce((result, item) => {
    const key = getKey(item);
    return {
      ...result,
      [key]: [...(result[key] || []), item],
    };
  }, {});
}
